import superagent from "superagent";

import { forms } from "./demo/forms";

export async function getFormFromDemoData(share_code) {
  const form = forms.find(form => form.share_code === share_code);
  if (form) {
    return form;
  }
  return undefined;
}

export async function getForm(share_code) {
  let asset = await getFormFromDemoData(share_code);
  if (!asset) {
    try {
      asset = await superagent
        .get(
          process.env.VUE_APP_API_ORIGIN +
            "/api/v1/inspection-forms/share-code/" +
            share_code
        )
        .then(({ body }) => {
          return body.data;
        });
    } catch (err) {
      console.error(err);
    }
  }
  return asset;
}
